export default function priceToString(amount: number): string {
  return Intl.NumberFormat('en-US', {currency: 'USD', style: 'currency'}).format(amount / 100)
}
